import PropTypes from "prop-types";
import useTranslations from "@hooks/useTranslations";

const PortfolioCard = ({ element, modalId, onOpen }) => {
  const t = useTranslations();

  return (
    <div className="col-md-6">
      <div className="isotop-item w-100">
        <div className="fillter-item bg-prink">
          <button
            className="img portfolio-btn portfolio-btn--block"
            data-bs-toggle="modal"
            data-bs-target={`#${modalId}`}
            onClick={onOpen}
            aria-label={`${t.a11y.viewProject} : ${element.nom}`}
          >
            <img src={element.image} alt={element.nom} loading="lazy" />
          </button>
          <h6 className="item-title">
            <button
              className="portfolio-btn"
              data-bs-toggle="modal"
              data-bs-target={`#${modalId}`}
              onClick={onOpen}
              aria-label={`${t.a11y.viewProjectDetails} : ${element.nom}`}
            >
              {element.nom}
            </button>
          </h6>
        </div>
      </div>
    </div>
  );
};

PortfolioCard.propTypes = {
  element: PropTypes.shape({
    nom: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
  }).isRequired,
  modalId: PropTypes.string.isRequired,
  onOpen: PropTypes.func,
};

export default PortfolioCard;
